import React, { useEffect, useState } from "react";
import "./Contact.css";
import { Card } from "primereact/card";
import Swal from "sweetalert2";

import { Message } from "primereact/message";
import { InputTextarea } from "primereact/inputtextarea";
import ContactUsimg from "../../Images/ContactUsImage.png";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { FiRefreshCw } from "react-icons/fi";
import { IoCallOutline, IoLocationOutline } from "react-icons/io5";
import { TbWorldWww } from "react-icons/tb";
import { TfiEmail } from "react-icons/tfi";
import { Link } from "react-router-dom";
import { BiLocationPlus } from "react-icons/bi";
import { FaLocationPin } from "react-icons/fa6";
import { GrLocation } from "react-icons/gr";
import './HelloEMSPricing'
// import HelloEMSPricing from "./HelloEMSPricing";
import HelloEMSPricing from "./HelloEMSPricingNew";
import FAQ from "./FAQ"

function Contact() {
  const [invalid, setInvalid] = useState(false);

  const [answer, setAnswer] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [text, setText] = useState("");
  const [fullName, setFullName] = useState("");
  const [emailID, setEmailID] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [contactReason, setContactReason] = useState("");
  const [mobilePrefix, setMobilePrefix] = useState(91);

  const generateCaptcha = () => {
    const number1 = Math.floor(Math.random() * 10) + 1;
    const number2 = Math.floor(Math.random() * 10) + 1;
    const operation = Math.random() < 0.5 ? "+" : "-";
    const result = operation === "+" ? number1 + number2 : number1 - number2;

    setCaptchaText(`${number1} ${operation} ${number2} = `);
    setAnswer(result.toString());
  };
  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleSaveContactUsEnquiry = async (event) => {
    event.preventDefault();
    if (answer === text) {
      setInvalid(false);
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Captcha",
        text: "Please enter a valid Captcha",
        timer: 2000,
        showConfirmButton: false,
      });
      setInvalid(true);
      generateCaptcha();
      return;
    }
    if (!fullName || fullName.length < 3 || fullName.length > 50) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a valid full name (between 3 and 50 characters).",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    if (!emailID || !/\S+@\S+\.\S+/.test(emailID)) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a valid email address.",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    if (!mobileNumber || mobileNumber.length !== 10 || isNaN(mobileNumber)) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a valid 10-digit mobile number.",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    if (!subject || subject.length < 3 || subject.length > 200) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a subject (between 2 and 200 characters).",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    if (
      !contactReason ||
      contactReason.length < 3 ||
      contactReason.length > 1000
    ) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a contact reason (between 3 and 1000 characters).",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    try {
      const response = await fetch("/saveContactUsEnquiry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: fullName,
          emailID: emailID,
          mobileNumber: parseInt(mobilePrefix + "" + mobileNumber),
          subject: subject,
          contactReason: contactReason,
        }),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Contact form data saved successfully.",
          timer: 2000, // 3 seconds
          showConfirmButton: false,
        });
        // Optionally reset form fields after successful submission
        setFullName("");
        setEmailID("");
        setMobilePrefix("+91");
        setMobileNumber("");
        setSubject("");
        setContactReason("");
        setText("");
        generateCaptcha();
      } else {
        console.error("Failed to save contact form data");
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to save contact form data. Please try again later.",
          timer: 2000, // 3 seconds
          showConfirmButton: false,
        });
        // Handle error scenario if needed
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while saving contact form data. Please try again later.",
        timer: 2000, // 3 seconds
        showConfirmButton: false,
      });
      console.error("Error occurred while saving contact form data:", error);

      // Handle network or other errors
    }
  };

  const handleMailClick = () => {
    const emailAddress = "support@clotatechnology.com"; // Replace with your email address
    window.open(`mailto:${emailAddress}`, "_blank");
  };
  const handlePhoneClick = () => {
    const phoneNumber = "+91-9490384177"; // Replace with your phone number
    window.open(`tel:+91 9490384177`, "_blank");
  };
  const handleWebsiteClick = () => {
    console.log("hey");
    window.open(`https://www.clotatech.com/`, "_blank");
  };
  const handleAddressClick = () => {
    console.log("hey");
    window.open(
      `https://www.google.com/maps/place/WeWork+Raheja+Mindspace/@17.4410208,78.3627964,15z/data=!3m1!5s0x3bcb915dccf46fc7:0x99a52272bcfe9c03!4m10!1m2!2m1!1sSurvey+no+64+Building+Number+9+K+Raheja+Mindspace+Madhapur+Shaikpet+Hyderabad+Telangana+India+500081!3m6!1s0x3bcb93547b7c9039:0x852fa9e76e4ca65!8m2!3d17.4410208!4d78.3808208!15sCmRTdXJ2ZXkgbm8gNjQgQnVpbGRpbmcgTnVtYmVyIDkgSyBSYWhlamEgTWluZHNwYWNlIE1hZGhhcHVyIFNoYWlrcGV0IEh5ZGVyYWJhZCBUZWxhbmdhbmEgSW5kaWEgNTAwMDgxWmYiZHN1cnZleSBubyA2NCBidWlsZGluZyBudW1iZXIgOSBrIHJhaGVqYSBtaW5kc3BhY2UgbWFkaGFwdXIgc2hhaWtwZXQgaHlkZXJhYmFkIHRlbGFuZ2FuYSBpbmRpYSA1MDAwODGSARpvZmZpY2Vfc3BhY2VfcmVudGFsX2FnZW5jeZoBI0NoWkRTVWhOTUc5blMwVkpRMEZuU1VSTWIxOVBhMVJSRUFFqgGhAgoIL20vMDNyazAKCS9tLzAzeDVuZgoIL20vMDljNncKCS9tLzBia3R5cBABKmgiZHN1cnZleSBubyA2NCBidWlsZGluZyBudW1iZXIgOSBrIHJhaGVqYSBtaW5kc3BhY2UgbWFkaGFwdXIgc2hhaWtwZXQgaHlkZXJhYmFkIHRlbGFuZ2FuYSBpbmRpYSA1MDAwODEoADIfEAEiG79_oVOkktojw1bl0mC4kGkTen55bfvmyafGAjJoEAIiZHN1cnZleSBubyA2NCBidWlsZGluZyBudW1iZXIgOSBrIHJhaGVqYSBtaW5kc3BhY2UgbWFkaGFwdXIgc2hhaWtwZXQgaHlkZXJhYmFkIHRlbGFuZ2FuYSBpbmRpYSA1MDAwODHgAQD6AQQIABAa!16s%2Fg%2F11krwxc9t8?entry=ttu&g_ep=EgoyMDI1MDUwNy4wIKXMDSoASAFQAw%3D%3D/`,
      "_blank"
    );
  };

  return (
    <>

    <div className="ContactSection">
      <div className="contact-subsection-left">
        <div className="innersection-left">
          <img src={ContactUsimg} alt="contactimage" />
          <p>Feel Free to reach out to us!</p>
          <div className="contacts-sources">
            <Message
              className="d-block"
              severity="info"
              text="+91-9490384177"
              onClick={handlePhoneClick}
              icon={<IoCallOutline className="contact-icon" />}
            />
            <Message
              className="d-block"
              severity="info"
              text="support@clotatechnology.com"
              onClick={handleMailClick}
              icon={<TfiEmail className="contact-icon" />}
            />
            <Message
              className="d-block"
              severity="info"
              style={{ marginBottom: "30px" }}
              onClick={handleWebsiteClick}
              text="www.clotatech.com"
              icon={<TbWorldWww className="contact-icon" />}
            />
          </div>
        </div>
      </div>


      <div className=" contact-subsection-right">
        <h2 className="Contact-heading">Contact Us</h2>

        <Card style={{ boxShadow: "none" }} className="contact-form">
          <form onSubmit={handleSaveContactUsEnquiry} method="post">
            <table className="contact-form-table" cellPadding={"8px"}>
              <tbody>
                <tr>
                  <td colSpan={2} className="floating-label-container">
                    <InputText
                      keyfilter={/^[a-zA-Z ]*$/}
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      pattern=".{3,50}"
                      placeholder=" "
                    />
                    <div className="label-line">Enter Your Name</div>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={2}
                    className="floating-label-container mobile-label">
                    <Dropdown
                      options={[{ name: "+91", value: 91 }]}
                      value={mobilePrefix}
                      onChange={(e) => setMobilePrefix(e.value)}
                      optionLabel="name"
                      placeholder="+91"
                      style={{ zIndex: "2" }}
                      className="drop-down-contact"
                    />
                    <InputText
                      className="contact-number "
                      keyfilter="pint"
                      placeholder=" "
                      pattern=".{10}"
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                    />
                    <div className="label-line">Contact Number</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} className="floating-label-container">
                    <InputText
                      type="email"
                      placeholder=" "
                      keyfilter={"email"}
                      value={emailID}
                      onChange={(e) => setEmailID(e.target.value)}
                    />
                    <div className="label-line">Enter Your Email</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} className="floating-label-container">
                    <InputText
                      pattern=".{3,200}"
                      type="text"
                      keyfilter={/^[a-zA-Z ]*$/}
                      placeholder=" "
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                    <div className="label-line">Enquiry About</div>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2} className="floating-label-container">
                    <InputTextarea
                      style={{ width: "100%" }}
                      rows={5}
                      keyfilter={/^[a-zA-Z0-9 ]*$/}
                      value={contactReason}
                      placeholder=" "
                      onChange={(e) => setContactReason(e.target.value)}
                      cols={30}
                    />
                    <div className="label-line">Reason</div>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "0px" }} colSpan={2}>
                    <div className="captcha">
                      {captchaText}{" "}
                      <FiRefreshCw
                        onClick={generateCaptcha}
                        className="captcha-icon"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="floating-label-container">
                    <InputText
                      keyfilter={"int"}
                      value={text}
                      placeholder=" "
                      onChange={(e) => setText(e.target.value)}
                    />
                    <div className="label-line">Enter Captcha</div>
                    {invalid && (
                      <p
                        style={{
                          color: "red",
                          margin: "0",
                          marginTop: "10px",
                        }}>
                        Invalid Captcha
                      </p>
                    )}
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <Button
                      disabled={
                        !fullName ||
                        !emailID ||
                        !mobileNumber ||
                        !subject ||
                        !contactReason ||
                        !text
                      }
                      label="Submit"
                      type="submit"
                      // onClick={() => generateCaptcha()}
                      style={{ width: "100%" }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </Card>


      </div>

    </div>

<div className="ContactSectionFAQ">
<FAQ/>
</div>


{/* --- SEO Optimized Section --- */}
{/* <section className="p-mt-5">
  <h2 className="p-mb-2">Streamline HR Management in India with HelloEMS</h2>
  <p className="p-text-justify" style={{maxWidth: 900}}>
    <strong>HelloEMS</strong> is India’s leading Employee Management and HR software, trusted by startups and established businesses. 
    Our platform unifies <strong>attendance tracking</strong>, <strong>payroll automation</strong>, <strong>leave management</strong>, and <strong>employee onboarding</strong> into a single, easy-to-use web-based solution. 
    Designed for small to large enterprises, HelloEMS boosts HR efficiency, ensures compliance, and keeps your data secure with advanced technologies.
  </p>
  <div className="p-grid p-mt-3">
    <div className="p-col-12 p-md-4">
      <h3>Why choose HelloEMS?</h3>
      <ul>
        <li>Easy online HR management for Indian businesses</li>
        <li>Payroll, attendance & leave tools in one place</li>
        <li>Mobile & desktop friendly, no extra app needed</li>
        <li>Compliant with Indian payroll laws</li>
      </ul>
    </div>
    <div className="p-col-12 p-md-8">
      <h3>Service Areas Covered</h3>
      <p>
        HelloEMS is available for businesses across major Indian cities—Hyderabad, Bangalore, Mumbai, Delhi, and more. 
        We offer customized solutions for tech parks, SMEs, factories, and remote workforces.
      </p>
    </div>
  </div>
  <p className="p-mt-2" style={{fontSize: '1rem'}}>
    <i>
      Upgrade your HR process and experience seamless management. <strong>Start your free HelloEMS trial today!</strong>
    </i>
  </p>
</section> */}

              
    </>
  );
}

export default Contact;
